<template>
  <router-link :to="to">
    <div class="img">
      <img :src="item.previewImageUrl" :alt="item.title" loading="lazy"/>
      <div  v-if="isNew" class="status-badge-wrap">
        <div class="status-badge">New</div>
      </div>
    </div>
    <div class="txt-box">
      <h3 class="title">
        <span class="text">{{ item.title }}</span>
        <HeartButton v-model:isLike="localIsLike"  :uuid="item.uuid" :likeType="item.likeType" />
      </h3>
      <p>{{ item.subTitle }}</p>
    </div>
  </router-link>
</template>

<script setup>
import {computed, defineEmits, defineProps, ref} from 'vue';
import HeartButton from "@/components/ui/HeartButton.vue";

const props = defineProps({
  isLike: Boolean,
  item: Object,
  to: Object,
});
const isLike = ref(props.isLike);

const emit = defineEmits(["update:isLike"]);

const localIsLike = computed({
  get: () => isLike.value,
  set: (newValue) => {
    isLike.value = newValue;
    emit("update:isLike", newValue);
  }
});


const parseDate = (str) => {
  const [year, month, day] = str.split('.').filter(Boolean).map(Number)
  return new Date(year, month - 1, day);
}

const isNew = computed(() => {
  const createdDate = parseDate(props.item.createdAt);
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const diffTime = today.getTime() - createdDate.getTime();
  const diffDays = diffTime / (1000 * 60 * 60 * 24);
  return diffDays < 7
})

</script>

<style scoped>
.status-badge-wrap {
  position: absolute;
  top: 10px;
  right: 9px;
}

.status-badge-wrap .status-badge {
  width: clamp(45px, 8.0vw, 92px);
  height: clamp(15px, 4.0vw, 36px);

  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 10px;

  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.6);
  border-radius: 5px;
  background: #FFFFFF;

  font-family: 'Poppins';
  font-style: normal;
  font-weight: 600;
  font-size: clamp(8px, 1.6vw, 14px);
  text-align: center;
  color: #151419;
}

.img {
  position: relative;
}

.img img {
  aspect-ratio: 647 / 394.6;
  /*object-fit: cover;*/
}

.txt-box {
  display: flex;
  flex-direction: column;
}

.title {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;
  gap: 5px;
}

.title span {
  font-size: clamp(14px, 3.5vw, 20px);
  font-weight: bold;
  flex-grow: 1;
  flex-basis: 0;
  text-align: left;
  letter-spacing: -0.6px;
  color: #fff;
  position: relative;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.article .list-type3>ul li button.btn-heart {
  position: static;
  bottom: auto;
  right: auto;
}

@media (max-width: 460px) {
  .status-badge-wrap {
    top: 6px;
    right: 5px;
  }

  .status-badge-wrap .status-badge {
    border-radius: 3px;
    letter-spacing: -0.05em;
  }
}
</style>